<template>
  <input
    :value="value"
    :class="c()"
    @input="updateValue"
  >
</template>

<script>
import {cn} from '@/app/js/classname'

const c = cn('answer-input')
export default {
  name: 'AnswerInput',
  props: {
    value: {
      type: String,
      default: null
    }
  },
  emits: ['input'],
  methods: {
    c,
    updateValue({target}) {
      this.$emit('input', target.value)
    }
  }
}
</script>

<style lang="scss">
.answer-input {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 7px 18px 9px;
  border: 1px solid #E4E4E4;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  transition: border-color .3s;
  resize: none;

  &::placeholder {
    color: #545454;
  }

  &:focus, &:hover {
    border-color: #000;
  }
}
</style>
